import { Component, OnInit, Output, EventEmitter, Inject, ViewChild,  } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '../../core/services/auth.service';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { Observable, map, timer } from 'rxjs';
import { DataManager, Query, ODataV4Adaptor, Predicate } from '@syncfusion/ej2-data';
import { changesLayout } from 'src/app/store/layouts/layout.actions';
import { getLayoutMode } from 'src/app/store/layouts/layout.selector';
import { RootReducerState } from 'src/app/store';
import { ItemModel } from '@syncfusion/ej2-angular-splitbuttons';
import { DialogComponent, PositionDataModel } from '@syncfusion/ej2-angular-popups';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit {
  notificationsEnabled = false;
  
  @ViewChild('Dialog') public Dialog: DialogComponent;
  
  messages: string[] = [
    '🚀 Welcome to Tally Support Center! Stay tuned for updates and announcements!',
  ];
  mode: any
  element: any;
  cookieValue: any;
  flagvalue: any;
  unReadCount: number = 0;
  data: DataManager;
  countryName: any;
  valueset: any;
  query: Query;
  theme: any;
  layout: string;
  dataLayout$: Observable<string>;
  baseUrl: string = environment.baseUrl.replace('/api/', '/odata/');
  user: any;
  public items: ItemModel[] = [{text: 'Change Password'},{text: 'Logout'}];
  public position: PositionDataModel = { X: 'right', Y: 'top' };

  constructor(@Inject(DOCUMENT) private document: any, private router: Router, private authService: AuthenticationService,
    public languageService: LanguageService,
    public translate: TranslateService,
    public _cookiesService: CookieService, public store: Store<RootReducerState>) {

  }

  listLang: any = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];

  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  ngOnInit() {
    // this.initialAppState = initialState;
    this.store.select('layout').subscribe((data) => {
      this.theme = data.DATA_LAYOUT;
    })
    this.user = this.authService.currentUserValue;
    this.openMobileMenu = false;
    this.element = document.documentElement;
    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }

    if (this.notificationsEnabled) {
      this.data = new DataManager({
        url: this.baseUrl + "Notifications",
        adaptor: new ODataV4Adaptor(),
        headers: [{ 'Authorization': 'Bearer ' + this.user.token }]
      });
      
      this.query = new Query().expand('To').where('IsRead', 'equal', false);
    }
    // const source = timer(0,60000);
    // const subscribe = source.subscribe(
    //   val => {        
    //     this.data.executeQuery(this.query)
    //     .then(e => {
    //       let a:any = e;
    //       this.unReadCount = a.result.length;  // This will log the count of the data items
    //   });
    //   }
    // ) 
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  profileList(e:any){
    switch (e.item.text) {
      case "Change Password":
        this.router.navigate(['/profile/change-password']);
        break;
      case "Logout":
        this.authService.logout();
        this.router.navigate(['/auth/login']);
        break;
      // case "Profile":
      //   this.router.navigate(['/profile/profileinfo']);
      default:
    }
  }
  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  changeLayout(layoutMode: string) {
    this.theme = layoutMode;
    this.store.dispatch(changesLayout({ layoutMode }));
    this.store.select(getLayoutMode).subscribe((layout) => {
      document.documentElement.setAttribute('data-layout', layout)
    })
  }

  openDialog(){
    if (this.notificationsEnabled) {
      this.Dialog.show();
    }
  }

  refreshCount(){
    this.unReadCount  = this.unReadCount  - 1;
  }
}
